module.exports = __webpack_public_path__ + "fa-solid-900.svg?5e46e9273987b5d795c439f84526f147";